import React, { useState } from 'react'
import { Box, ButtonBase, Container, Paper, Typography } from '@mui/material'
import departments from "../../data/departments.json"

const ClientSelector = (props) => {

  const [ clientSelection, setClientSelection ] = useState(null);

  const data = [
    {
      id: "9427c834-1bb6-4c3a-905e-e324d0558976",
      name: "Manufacturer",
      icon: "",
      short_description: "Get Your Products in Our Software",
      long_description: "Enable thousands of users to design and plan their rooms using your products. Using Personal Architect, your customers can easily view your products in a space that they create and checkout immediately after. Increase revenue by enabling your customers to shop in an interactive environment that encourages purchasing of your products.",
    },
    {
      id: "46eaf0f6-f6d3-4afb-9fe1-817207d373ec",
      name: "White Label",
      icon: "",
      short_description: "Get Our Software on Your Site",
      long_description: "Want to enable your users to create interior designs in your custom environment? Get a white-label version of our intuitive 3D cloud-based home design software, exclusively customized to your needs. Create a meaningful connection with your customers by empowering them to craft designs on your site.",
    },
    {
      id: "82c1c282-80da-4c9d-855e-2db8e93bc56c",
      name: "Tech Integration",
      icon: "",
      short_description: "Our Apps Can Work Together",
      long_description: "Personal Architect was built with technological expansion in mind. If you have ideas for how your software can integrate with Personal Architect, our development team can review opportunities with your business to see if there's is an opportunity for mutual growth.",
    },
  ]

  const handleClientSelection = (item) => {
    if (item !== clientSelection) {
      console.log("Added:", item)
      setClientSelection(item)
    } else {
      console.log("Removed:", item)
      setClientSelection(null)
    }
  }

  return (
    <Box>
      <Container>
        <Box sx={{alignItems: "center", display: "flex", flexWrap: "wrap", justifyContent: "space-around",}}>
          {
            data.map(item => (
              <Paper key={item.id} sx={{m: 1,}}>
                <ButtonBase onClick={() => { handleClientSelection(item) }} sx={{ minWidth: 300, p:3, }}>
                  <Box>
                    <Typography component="h2" fontWeight={500} textAlign="center" variant="h5">
                      {item.name}
                    </Typography>
                    <Typography>
                      {item.short_description}
                    </Typography>
                  </Box>
                </ButtonBase>
              </Paper>
            ))
          }
        </Box>
      </Container>
      <Container sx={{mt:3,}}>
          {
            clientSelection !== null ? (
              <Paper sx={{m: 1, p: 3,}}>
                <Box>
                  <Box sx={{my:1,}}>
                    <Typography component="h2" fontWeight={600} textAlign="center" variant="h3">{clientSelection.name}</Typography>
                    <Typography textAlign="center" variant="h5">{clientSelection.short_description}</Typography>
                    <Typography textAlign="center" sx={{m:2,}}>
                        {clientSelection.long_description}
                      </Typography>
                  </Box>
                </Box>
              </Paper>
            ) : null
          }
      </Container>
      <Container maxWidth="xl">
        <Typography component="h2" fontWeight={500} sx={{my:2,}} textAlign="center" variant="h4">Let Customers Visualize Your Products in 3D</Typography>
        <Box sx={{display: "flex", flexWrap: "wrap", justifyContent: "center",}}>
          {departments.map(department => (
            <Paper key={department.id} sx={{backgroundColor: department.color, borderTopRightRadius: 100, m:1, py:5, px:1,}}>
              <Box
                component="img"
                src={
                  process.env.NODE_ENV === "development" ? 
                  department.image :
                  "/wp-content/themes/personal-architect/" + department.image
                }
                width="200px"
                height="147px"
              ></Box>
              <Typography fontWeight={500} sx={{textAlign: "center", mt:2,}}>{department.name}</Typography>
            </Paper>
          ))}
        </Box>
      </Container>
    </Box>
  )
}

export default ClientSelector